import { ArrowRight, Clock, KeyRound } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import { useCurrentReseller } from '../../api/reseller';
import { useActiveBrand } from '../../api/brand';

/**
 * SSO landing — expired link — §8.1
 * Full-screen, brand-aware, reassuring.
 */
export function SsoExpired() {
  const { data: r } = useCurrentReseller();
  const brand = useActiveBrand();
  if (!r) return null;
  const accent = r.primaryColor;

  return (
    <div className="min-h-screen bg-marketing dark:bg-marketing-dark flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md text-center">
        <div className="flex flex-col items-center mb-7">
          <span
            className="w-12 h-12 rounded-xl grid place-items-center text-white font-semibold text-lg shadow-sm"
            style={{ backgroundColor: accent }}
            aria-hidden="true"
          >
            {r.displayName.charAt(0)}
          </span>
          <p className="mt-3 text-xs text-zinc-500 dark:text-zinc-400">
            {r.displayName}
          </p>
        </div>

        <div className="w-14 h-14 mx-auto mb-5 grid place-items-center rounded-full bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400">
          <Clock className="w-7 h-7" />
        </div>

        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-zinc-950 dark:text-zinc-50">
          Your link expired
        </h1>
        <p className="mt-3 text-sm text-zinc-600 dark:text-zinc-300 max-w-sm mx-auto">
          For your safety, sign-in links expire after a few minutes. Sign in again at the
          link below to continue to your POS.
        </p>

        <div className="mt-8 inline-flex flex-col items-stretch gap-2.5 w-full max-w-xs mx-auto">
          <Link
            to="/login"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md text-sm font-medium text-white shadow-sm transition hover:opacity-90"
            style={{ backgroundColor: accent }}
          >
            <KeyRound className="w-4 h-4" />
            Go to login
            <ArrowRight className="w-4 h-4" />
          </Link>
          <a
            href={`https://saas.${brand.domain}`}
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md text-sm font-medium text-zinc-900 dark:text-zinc-50 border border-zinc-300 dark:border-zinc-700 hover:bg-zinc-50 dark:hover:bg-zinc-900 transition"
          >
            Open saas.{brand.domain}
          </a>
        </div>

        <p className="mt-10 text-xs text-zinc-500 dark:text-zinc-400">
          Need help? Contact{' '}
          <a
            href={`mailto:${r.supportEmail}`}
            className="text-zinc-700 dark:text-zinc-200 hover:underline mono"
          >
            {r.supportEmail}
          </a>
        </p>
      </div>
    </div>
  );
}
